import { DefaultTheme } from 'styled-components';
import * as Colors from './alluvium-colors';

// Custom colors

const blueDarkest = Colors.primary800;

const primaryColor = Colors.primary600;
const primaryColorHover = Colors.primary450;
const primaryColorActive = Colors.primary700;

const darkAccent = Colors.primary600;

const goldAccent = Colors.gold600;

const brandAccent = Colors.coral500;

const headerDarkBg = blueDarkest;
const headerPrimaryBg = 'rgb(255, 255, 255)';

const tableHeaderBg = Colors.primary800;
const tableHeaderColor = Colors.textOnDarkMuted;

// Theme colors

const bodyTextColor = '#666';
const accentColor = '#453B3B';
const dangerColor = '#de2d1d';
const disabledColor = '#bbb';
const inactiveColor = '#abb1b8';
const successColor = '#34b364';
const warningColor = '#f6b926';

const black = '#22292f';
const greyDarkest = '#3d4852';
const greyDarker = Colors.neutral550;
const greyDark = '#8795a1';
const grey = '#b8c2cc';
const greyLight = '#dae1e7';
const greyLighter = '#f1f5f8';
const greyLightest = '#f8fafc';
const white = '#ffffff';

const chartColors = [
  accentColor,
  '#d13b65',
  successColor,
  '#f06d3a',
  warningColor,
  primaryColor,
  inactiveColor,
  '#d1d1d1',
];

export const alluviumTheme: DefaultTheme = {
  bodyTextColor,
  chartColors,
  accentColor,
  dangerColor,
  disabledColor,
  inactiveColor,
  successColor,
  primaryColor,
  primaryColorHover,
  warningColor,
  blueDarkest,
  black,
  greyDarkest,
  greyDarker,
  greyDark,
  grey,
  greyLight,
  greyLighter,
  greyLightest,
  white,
};

// UI surface colors
export const lightBg = Colors.ink50;
export const lightest = '#e0dcdc';
export const pageBg = '#f9f9f8';
export const rangePickerInRange = '#f0ece8';
export const focusShadow = 'rgba(107, 58, 58, 0.2)';

// Status tag colors - organized by hue
export const statusColors = {
  // Default/uncolored (Warm Gray)
  default: { bg: '#F5F3F1', border: '#D8D3CD', text: '#6B6360' },
  // Blue (Booked, Scheduled, In Review)
  blue: { bg: '#F2F5F8', border: '#9BBAC4', text: '#4A7080' },
  // Orange (Pending, Booking/Proposed)
  orange: { bg: '#FAF6ED', border: '#D4B86E', text: '#8B6914' },
  // Green (Patient Seen, Fulfilled, Confirmed)
  green: { bg: '#F3F7F0', border: '#9EC08E', text: '#4A6B3A' },
  // Red (No Show, Failed, Rejected, Cancelled)
  red: { bg: '#F8F1EF', border: '#D9A099', text: '#A0382E' },
  // Purple (Sent To External WorkQ)
  purple: { bg: '#F6F2F6', border: '#B9A2C4', text: '#6B4A7B' },
  // Yellow (Accepted)
  yellow: { bg: '#FBF7EE', border: '#D9C080', text: '#8B6914' },
} as const;

// Success color (warm sage)
export const successGreen = '#4A6B3A';
export const successGreenLight = '#9EC08E';

// Alert error description (slightly different from tag red)
export const alertErrorDescription = '#8B4040';

export const alluviumBranding = {
  primaryColor,
  primaryColorHover,
  primaryColorActive,
  darkAccent,
  goldAccent,
  brandAccent,
  headerDarkBg,
  headerPrimaryBg,
  tableHeaderBg,
  tableHeaderColor,
  logoPath: '/images/alluvium-logo-dark.svg',
  logoIconPath: '/images/alluvium-logo-dark.svg',
  logoWidth: '220px',
};
